import { render } from "./VodClipTrimmingModal.vue?vue&type=template&id=6ea0c5c4"
import script from "./VodClipTrimmingModal.vue?vue&type=script&lang=js"
export * from "./VodClipTrimmingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/VodClipTrimmingModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ea0c5c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ea0c5c4', __exports__)) {
    api.reload('6ea0c5c4', __exports__)
  }
  
  module.hot.accept("./VodClipTrimmingModal.vue?vue&type=template&id=6ea0c5c4", () => {
    api.rerender('6ea0c5c4', render)
  })

}


export default __exports__